import { render } from "./ChevronIcon.vue?vue&type=template&id=d31e137e"
import script from "./ChevronIcon.vue?vue&type=script&lang=js"
export * from "./ChevronIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__